import { Route, AppId, createPageRoute } from '@lumapps/router';

export const adminMainNavigationRoutes: Route = createPageRoute({
    slug: 'navigation',
    appId: AppId.backOffice,
});

export const adminMainNavigation = () => adminMainNavigationRoutes;
